export default "__VITE_ASSET__zdF_BCbu__"